import { Bar, BarChart, type BarShapeProps, XAxis, YAxis } from 'recharts'

interface MultipleXAxisBarChartProps {
  data1?: number
  data2?: number
  dataBackground?: number
}

const RectangleBorderTopBar = (props: BarShapeProps) => {
  const { width, height, x, y, fill, stroke, strokeWidth, strokeDasharray } = props
  const strokeWidthNumber = strokeWidth ? Number(strokeWidth) : 0

  return (
    <svg>
      <rect width={width} height={height} x={x} y={y} fill={fill} />
      <line
        x1={x}
        y1={y + strokeWidthNumber / 2}
        x2={x + width}
        y2={y + strokeWidthNumber / 2}
        style={{ stroke, strokeWidth, strokeDasharray }}
      />
    </svg>
  )
}

const MultipleXAxisBarChart = (chartProps: MultipleXAxisBarChartProps) => {
  const chartData = [
    {
      data1: chartProps.data1 ?? 0,
      data2: chartProps.data2 ?? 0,
      dataBackground: chartProps.dataBackground ?? 0
    }
  ]

  return (
    <div className="mg-multiple-xaxis-bar-chart">
      <BarChart
        responsive
        data={chartData}
        barSize={'30%'}
        barGap={'10%'}
        style={{ aspectRatio: 1.618 }}
        margin={{ top: 0, right: 0, bottom: 0, left: 0 }}
      >
        <YAxis domain={[0, 'dataMax']} hide />

        <XAxis dataKey="data1" xAxisId="name" orientation="top" hide />
        <XAxis
          dataKey="dataBackground"
          xAxisId="dataBackground"
          padding={{ left: -1, right: -1 }} // Remove the default padding to remove right/left blank spaces
          hide
        />

        <Bar
          dataKey="dataBackground"
          fill="var(--vp-semantic-color-status-info-quiet)"
          stroke="var(--vp-semantic-color-content-brand)"
          strokeWidth={2}
          strokeDasharray="5 5"
          xAxisId="dataBackground"
          barSize={'100%'}
          animationDuration={1000}
          shape={RectangleBorderTopBar}
        />
        <Bar dataKey="data1" fill="var(--vp-semantic-color-border-brand)" xAxisId="name" animationDuration={500} />
        <Bar
          dataKey="data2"
          fill="var(--vp-semantic-color-extended-turquoise)"
          xAxisId="name"
          animationDuration={500}
        />
      </BarChart>
    </div>
  )
}

export default MultipleXAxisBarChart
